<template >
<div class="col-12" v-if="$page.props.pagination">
    <nav aria-label="pagination" >
        <ul class="pagination justify-content-center">
             <li class="page-item" v-bind:class="{ 'disabled': $page.props.pagination.first_page_url == null}">
                <a v-if="$page.props.pagination.first_page_url == null" class="page-link" aria-label="First Page" >
                    <span aria-hidden="true">&laquo;</span>
                </a>
                <inertia-link v-else class="page-link" :href="$page.props.pagination.first_page_url" aria-label="First Page" >
                    <span aria-hidden="true">&laquo;</span>
                </inertia-link>
            </li>
            
            <li class="page-item" v-bind:class="{ 'disabled': $page.props.pagination.prev_page_url == null}">
                <a v-if="$page.props.pagination.prev_page_url == null" class="page-link" aria-label="Previous" >
                    <span aria-hidden="true">&lsaquo;</span>
                    <span class="sr-only">Previous</span>
                </a>
                <inertia-link v-else class="page-link" :href="$page.props.pagination.prev_page_url" aria-label="Previous" >
                    <span aria-hidden="true">&lsaquo;</span>
                    <span class="sr-only">Previous</span>
                </inertia-link>
            </li>
            
            <li class="page-item" v-bind:class="{ 'active': page.active }" v-for="page in $page.props.pagination.links" :key="page.index">
                <inertia-link class="page-link" :href="page.url">{{page.label}}</inertia-link>
            </li>

            <li class="page-item"  v-bind:class="{ 'disabled': $page.props.pagination.next_page_url == null}">
                <a v-if="$page.props.pagination.next_page_url == null" class="page-link" aria-label="Next">
                    <span aria-hidden="true">&rsaquo;</span>
                    <span class="sr-only">Next</span>
                </a>
                <inertia-link v-else class="page-link" :href="$page.props.pagination.next_page_url" aria-label="Next">
                    <span aria-hidden="true">&rsaquo;</span>
                    <span class="sr-only">Next</span>
                </inertia-link>
            </li>

             <li class="page-item" v-bind:class="{ 'disabled': $page.props.pagination.last_page_url == null}">
                <a  v-if="$page.props.pagination.last_page_url == null" class="page-link" aria-label="Last Page" >
                    <span aria-hidden="true">&raquo;</span>
                </a>

                <inertia-link v-else class="page-link" :href="$page.props.pagination.last_page_url" aria-label="Last Page" >
                    <span aria-hidden="true">&raquo;</span>
                </inertia-link>
            </li>
        </ul>
    </nav>
</div>
    
</template>



<script>
    export default {
        props:{
            "pagination":Array
        }
    }
</script>